import auth from './auth';
import authProcess from './authProcess';
import fleet from './fleet';
import twilio from './twilio';
import user from './user';
import vehicle from './vehicle';
import websocket from './websocket';

export default {
  auth,
  user,
  twilio,
  vehicle,
  fleet,
  websocket,
  authProcess,
};
